import { DeviceType } from "sb-resp-utils";
export class DeviceDetectHelper {
    constructor(deviceTypeDetect) {
        this.deviceDetect = deviceTypeDetect;
    }
    itemDeviceFilter(items) {
        return items.filter(item => !!item.AllowDevices[this.getDeviceType()]);
    }
    getDeviceType() {
        if (this.deviceDetect.isDesktop) {
            return DeviceType.desktop;
        }
        else if (this.deviceDetect.isMobile) {
            return DeviceType.mobile;
        }
        else if (this.deviceDetect.isTablet) {
            return DeviceType.tablet;
        }
        throw "not implemented device type";
    }
}
//# sourceMappingURL=DeviceDetectHelper.js.map